const locale = {
	BILLBUDDY: "BillBuddy",
	OVERVIEW: "Overview",
	WELCOMEBACK: "Welcome back",
};

export default locale;
